export default __webpack_public_path__ + "static/media/Horne Houston 4.ecf704b8.jpg";